import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'results']
  static values = { url: String }

  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.performSearch()
    }, 250)
  }

  async performSearch() {
    const query = this.inputTarget.value.trim()
    const url = new URL(window.location.origin + this.urlValue)
    if (query.length > 0) url.searchParams.set('search', query)

    const response = await fetch(url, {
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })

    if (response.ok) {
      const html = await response.text()
      this.resultsTarget.innerHTML = html
    }
  }
}
